import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';
// controller
import NumericFormatInputController, {
  IProps as INumericInputProps,
} from 'controllers/numeric-format-input-controller';
// api
import { ISelectionItem } from 'redux-store/api/selections';
// types
import { TInputArrowClickFunction } from '../../../../../utils/types';
import { ISelectionFormValues } from '../../../utils/types';

interface IProps extends INumericInputProps {}

type T = ISelectionFormValues['options'][number];

const QuantityInput: FC<IProps> = ({ name = 'quantity', ...props }) => {
  const form = useFormContext();

  const quantityValue = form.watch(name);

  const handleArrowClick: TInputArrowClickFunction = (type) => {
    form.setValue(name, type === 'up' ? quantityValue + 1 : quantityValue - 1);
  };

  return (
    <NumericFormatInputController
      fullWidth
      withError
      showEndAdornment
      name={name}
      label="Quantity"
      placeholder="E.g. 1"
      handleArrowClick={handleArrowClick}
      disableDownArrow={quantityValue <= 1}
      {...props}
    />
  );
};

export default QuantityInput;
